import Factory from './factory';

export default new Factory()
    .addProp('falseValue')
    .addProp('trueValue')
    .addPassthrough('falseValue')
    .addPassthrough('trueValue');
